export default "88376733d33376e1.png"